





























import { Vue, Component, Prop } from "vue-property-decorator";
import { bus } from "../../main";
@Component
export default class WelcomeDialog extends Vue {
  @Prop() openDialog!: boolean;
    private welcomeDialog: boolean
  private boolean: boolean
  private userType: string

  constructor() {
    super();
    this.welcomeDialog = false
    this.boolean = this.openDialog
    this.userType = 'student'
  }

  created(){
      bus.$on("openWelcome", (data: any) =>{
      this.welcomeDialog = true
      this.userType = data
    })
  }
}
